import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';

export default function RequireAuth({ children }: { children: ReactNode }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#fffaf4]">
        <div className="flex items-center gap-3 text-sm font-semibold text-slate-600">
          <i className="ri-loader-4-line animate-spin text-xl text-orange-500" />
          Carregando sua conta...
        </div>
      </div>
    );
  }

  if (!user) {
    const next = location.pathname + location.search;
    return <Navigate to={`/criar-conta?next=${encodeURIComponent(next)}`} replace />;
  }

  return <>{children}</>;
}
